import React, { JSX } from 'react';
import { Box } from '@mui/material';
import { BackstoryTextFieldRef } from 'components/BackstoryTextField';
import {
  Candidate,
  CandidateQuestion,
  ChatMessage,
  ChatMessageError,
  ChatMessageStatus,
  ChatSession,
  Resume,
} from 'types/types';
import { ChatComposer } from './CandidateChatComposer';
import { CandidateHeader, ChatMessageList } from './CandidateChatMessages';
import { SuggestedQuestions } from './CandidateChatQuestions';

interface ChatPanelProps {
  resume: Resume | null;
  selectedCandidate: Candidate;
  chatSession: ChatSession | null;
  messages: ChatMessage[];
  processingMessage: ChatMessage | ChatMessageError | ChatMessageStatus | null;
  streamingMessage: ChatMessage | null;
  streaming: boolean;
  loading: boolean;
  isMobile: boolean;
  defaultQuestions: string[];
  welcomeMessage: ChatMessage;
  messagesEndRef: React.RefObject<HTMLDivElement | null>;
  backstoryTextRef: React.RefObject<BackstoryTextFieldRef | null>;
  onDelete: (session: ChatSession) => Promise<void>;
  onSendMessage: (message: string) => Promise<void>;
  onSubmitQuestion: (question: CandidateQuestion) => void;
}

function ChatPanelContent(props: ChatPanelProps): JSX.Element {
  return (
    <Box
      sx={{
        display: props.isMobile ? 'grid' : 'flex',
        flexDirection: 'column',
        gridTemplateRows: props.isMobile
          ? props.resume
            ? 'minmax(0, 1fr) auto auto'
            : 'auto minmax(0, 1fr) auto auto'
          : undefined,
        width: props.isMobile ? '100%' : '50%',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
        p: props.isMobile ? 0 : 1,
        m: props.resume ? 0 : '0 auto',
        position: 'relative',
        backgroundColor: 'background.paper',
      }}
    >
      {!props.resume && (
        <CandidateHeader selectedCandidate={props.selectedCandidate} isMobile={props.isMobile} />
      )}
      <ChatMessageList {...props} />
      <SuggestedQuestions
        resume={props.resume}
        selectedCandidate={props.selectedCandidate}
        defaultQuestions={props.defaultQuestions}
        isMobile={props.isMobile}
        onSubmitQuestion={props.onSubmitQuestion}
      />
      <ChatComposer
        chatSession={props.chatSession}
        streaming={props.streaming}
        loading={props.loading}
        isMobile={props.isMobile}
        backstoryTextRef={props.backstoryTextRef}
        onDelete={props.onDelete}
        onSendMessage={props.onSendMessage}
      />
    </Box>
  );
}

export { ChatPanelContent };
